<template>
    <div>
        <p>Hola</p>
        <edit-user v-if="ready" :uuid="user.uuid"></edit-user>
    </div>
</template>

<script>
    export default {
        name: "Edit",
        props: {
            uuid: String,
        },
        data() {
            return {
                loading: false,
                user: {},
                ready: false,
            }
        },
        mounted() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent() {
                this.loading = false;
                this.$root.preloader = false;
                this.getUser();
            },
            getUser() {
                this.ready = false;
                this.$http.get('/ivr/worker/' + this.uuid).then(response => {
                    this.user = response.data.data.user;
                    if(this.user.worker){
                        this.user.personal_phone = this.user.worker.personal_phone;
                        this.user.extension = this.user.worker.extension;
                        this.user.role = 'ivr_worker';
                    }
                    setTimeout(() => {
                        this.ready = true;
                    }, 500)
                }, error => {
                    this.ready = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>
